export default [
  {
    path: '/tickets',
    name: 'tickets',
    component: () => import('@/views/tickets/TicketsList.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/tickets/nuevo',
    name: 'ticketNew',
    component: () => import('@/views/tickets/TicketNew.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: '/tickets/:ticketId',
    name: 'ticketDetail',
    component: () => import('@/views/tickets/TicketDetail.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
]
